module.exports = __webpack_public_path__ + "static/media/saunatimeTwitter-600x314.509c5aa7.jpg";